import React from 'react'
import Slider from 'react-slick'
import styles from './login.module.css'

const Index = () => {
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };
    return (
        <React.Fragment>
                <div className='my-5'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className={`${styles['top-comp']} card`}>
                                    <div className='card-body py-3'>
                                        <div className='row'>
                                            <div className='col-md-12 mb-4 text-center'>
                                                <h2 className={`${styles['sec-title']}`}>Top companies hiring on <span className={`${styles['text-blue']}`}>JobzShala</span></h2>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className="slider-container">
                                                    <Slider {...settings}>
                                                        <div className='mx-3'>
                                                            <div className={`${styles['com-box']}`}>
                                                                <img src='https://cdn.jobzseed.com/employer/images/company/clickup.png' />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={`${styles['com-box']}`}>
                                                                <img src='https://cdn.jobzseed.com/employer/images/company/elastic.png' />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={`${styles['com-box']}`}>
                                                                <img src='https://cdn.jobzseed.com/employer/images/company/freshbooks.png' />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={`${styles['com-box']}`}>
                                                                <img src='https://cdn.jobzseed.com/employer/images/company/dropbox.png' />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={`${styles['com-box']}`}>
                                                                <img src='https://cdn.jobzseed.com/employer/images/company/github.png' />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={`${styles['com-box']}`}>
                                                                <img src='https://cdn.jobzseed.com/employer/images/company/helpscout.png' />
                                                            </div>
                                                        </div>
                                                    </Slider>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles['bg-light-blue']}`}>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <h3 className={`${styles['third-title']}`}>Ultimate Destination for Job Posting and Recruitment</h3>
                                <p className={`${styles['common-para']} my-3`}>Unlock the potential of your recruitment strategy with JobzShala's unparalleled job posting services – Unleash a wave of top-quality job applications.</p>
                                <div className='row d-flex flex-row flex-wrap justify-content-center'>
    <div className='col-4 col-md-4 text-center'>
        <div>
            <h4 className={`${styles['count-hd']}`}>500+</h4>
            <h4 className={`${styles['count-para']}`}>MNC posting <br />jobs daily</h4>
        </div>
    </div>
    <div className='col-4 col-md-4 text-center'>
        <div>
            <h4 className={`${styles['count-hd']}`}>2K+</h4>
            <h4 className={`${styles['count-para']}`}>Roles and <br />Industries</h4>
        </div>
    </div>
    <div className='col-4 col-md-4 text-center'>
        <div>
            <h4 className={`${styles['count-hd']}`}>7K+</h4>
            <h4 className={`${styles['count-para']}`}>Placed <br />Candidates</h4>
        </div>
    </div>
</div>

                            </div>
                            <div className='col-md-6'>
                                <div className="row mt-5 align-items-start mb-3">
                                    <div className="col-auto">
                                        <div className={`${styles['icon-box']}`}>
                                            <img src='https://cdn.jobzseed.com/employer/images/homepage/eduicon.svg' />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h5 className={`${styles['title-hd']}`}>Title 1</h5>
                                        <p className={`${styles['title-para']}`}>Effortlessly post job openings in just 2 minutes</p>
                                    </div>
                                </div>
                                <div className="row mt-4 align-items-start mb-3">
                                    <div className="col-auto">
                                        <div className={`${styles['icon-box']}`}>
                                            <img src='https://cdn.jobzseed.com/employer/images/homepage/edujobicon.svg' />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h5 className={`${styles['title-hd']}`}>Title 2</h5>
                                        <p className={`${styles['title-para']}`}>Witness a deluge of unlimited applications</p>
                                    </div>
                                </div>
                                <div className="row mt-4 align-items-start mb-3">
                                    <div className="col-auto">
                                        <div className={`${styles['icon-box']}`}>
                                            <img src='https://cdn.jobzseed.com/employer/images/homepage/edubuildicon.svg' />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h5 className={`${styles['title-hd']}`}>Title 3</h5>
                                        <p className={`${styles['title-para']}`}>Captivate a diverse and enthusiastic audience</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12 my-5 text-center'>
                            <h4 className={`${styles['hire-title']}`}>Hiring Made Easy</h4>
                        </div>
                    </div>
                    <div className='row mb-4'>
                        <div className='col-md-6 py-3 d-flex flex-column justify-content-center'>
                            <div className='d-flex align-items-center'>
                                <span className={`${styles['number-txt']}`}>1</span>
                                <span className={`${styles['number-title']}`}>Get access to <br />High-quality Talent</span>
                            </div>
                            <p className={`${styles['number-para']} mt-3`}>Post a job in minutes and get it noticed by the relevant candidates quickly</p>
                        </div>
                        <div className='col-md-6 py-3'>
                            <img className='img-fluid' src='https://cdn.jobzseed.com/employer/images/homepage/talent.svg' />
                        </div>
                        <div className='col-md-12 text-center position-relative'>
                            <div className={`${styles['img-arrow']}`}>
                                <img src='https://cdn.jobzseed.com/employer/images/homepage/arrow1.svg' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles['bgct-light']} py-4`}>
                    <div className='container'>
                        <div className='row mb-4'>
                            <div className='col-md-6'>
                                <img className='img-fluid' src='https://cdn.jobzseed.com/employer/images/homepage/screening-candidates.svg' />
                            </div>
                            <div className='col-md-6 d-flex flex-column justify-content-center'>
                                <div className='d-flex align-items-center'>
                                    <span className={`${styles['number-txt']}`}>2</span>
                                    <span className={`${styles['number-title']}`}>Effective Screening <br />of Candidates</span>
                                </div>
                                <p className={`${styles['number-para']} mt-3`}>Let our Machine Learning algorithms lift the heavy task of sorting applications most relevant to your job posting</p>
                            </div>
                            <div className='col-md-12 text-center position-relative'>
                                <div className={`${styles['img-arrow']}`}>
                                    <img src='https://cdn.jobzseed.com/employer/images/homepage/arrow2.svg' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='row mb-4'>
                        <div className='col-md-6 py-4 d-flex flex-column justify-content-center'>
                            <div className='d-flex align-items-center'>
                                <span className={`${styles['number-txt']}`}>3</span>
                                <span className={`${styles['number-title']}`}>Use Of Smart Tools</span>
                            </div>
                            <p className={`${styles['number-para']} mt-3`}>Tools like chat, video/audio calls, and interview schedulers help you reduce the manual work making it easy to connect with the candidates</p>
                        </div>
                        <div className='col-md-6 py-3'>
                            <img className='img-fluid' src='https://cdn.jobzseed.com/employer/images/homepage/smarttools.svg' />
                        </div>
                    </div>
                </div>
        </React.Fragment>
    )
}

export default Index